import * as React from "react"
import {ApplicationContext} from "../../ApplicationContext";
import {CmsContent} from "../../Model/CmsContent/CmsContent";
import SuperdrugSimOnlyOrderConfirmationPage from "./SuperdrugSimOnlyOrderConfirmationPageProps";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";
import {Navigate} from "react-router-dom";
import {COUNTER_PAGE_LOAD} from "../../Service/CounterMetricsProvider";

interface SimOnlyOrderConfirmationPageProps {

    /**
     * Array of all content currently stored in the CMS that has been made available to the Sales Portal.
     */
    readonly cmsContent: CmsContent[]

}

/**
 * Function will render the order confirmation page for a recently placed SIM-only order.
 */
const SimOnlyOrderConfirmationPage = (props: SimOnlyOrderConfirmationPageProps): JSX.Element => {

    const applicationContext = React.useContext(ApplicationContext)

    React.useEffect(() => {
        window.scrollTo(0, 0)
        COUNTER_PAGE_LOAD.emit({
            severityNumber: 9,
            severityText: "INFO",
            body: "",
            attributes: {"page": "/sim-only/confirmation"}
        });
    }, [])

    if (applicationContext.reseller === "superdrug") {
        return <SuperdrugSimOnlyOrderConfirmationPage cmsContent={props.cmsContent}/>
    } else {
        return <Navigate to={SALES_PORTAL_ROUTES.NotFound(applicationContext.urlContext)}/>
    }

}

export default SimOnlyOrderConfirmationPage